import { useIsDesktopViewport } from "@app/shared/hooks/useIsDesktopViewport";
import { HomePage } from "./HomePage";
import { DesktopHomePage } from "./DesktopHomePage";

/**
 * Element mounted at the root tracking URL (`/:trackCode`, `/d/:trackCode`).
 * Mobile/tablet keep the existing full-screen-map `HomePage` untouched;
 * desktop swaps in `DesktopHomePage` instead, since `DesktopTrackingShell`
 * already renders the map in its own permanent pane there. Kept as a plain
 * breakpoint switch (not a "desktop version of Home") so each page's hooks
 * only ever run when that page is actually the one mounted.
 */
export const HomeRoute = () => {
  const isDesktop = useIsDesktopViewport();
  return isDesktop ? <DesktopHomePage /> : <HomePage />;
};
